<template>
  <UnauthorizedBlock>
    <div class="text-md text-center text-text font-medium mb-12">
      {{ $t('welcomeTitle') }}
    </div>
    <div class="text-sm text-center text-text font-medium mb-6"
         v-show="!!user_info.data.invitations"
         v-html="$t('hasInvitesText')">
    </div>
    <div class="divide-y divide-border space-y-6 mb-12">
      <div v-for="(invite,i) in invitations" :key="i" class="pt-6">
        <div class="text-lg text-center text-text mb-6"
             v-html="inviteText(invite.author.username || invite.author.email,invite.space.title)">
        </div>
        <BaseButton theme="green" class="w-full" @click="accept(invite.id)">
          {{ $t('acceptInvite') }}
        </BaseButton>
      </div>
    </div>
    <div class="flex flex-wrap justify-center pt-6" style="margin:0 -5rem">
      <div class="w-full bg-line h-px"></div>
      <div class="text-text-ternary text-2sm px-8 bg-block transform -translate-y-1/2">{{ $t('or') }}</div>
    </div>
    <BaseButton theme="red" class="w-full mt-8" @click="goToCreate">{{ $t('createSpaceText') }}</BaseButton>
  </UnauthorizedBlock>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import BaseButton from "@/components/UI/BaseButton";
import UnauthorizedBlock from "@/components/layouts/common/UnauthorizedBlock";


export default {
  name: "TheIntro",
  components: {
    UnauthorizedBlock,
    BaseButton,
    TopGradientBlockLayout,
  },
  computed: {
    ...mapState('cabinet/user', ['user_info']),
    ...mapState('auth', ['user']),
    ...mapState('cabinet/invitations', ['invitations']),
  },
  methods: {
    ...mapActions('space', ['getActiveSpaces']),
    ...mapActions('cabinet/user', ['setUserPrimarySpaceId']),
    ...mapActions('cabinet/invitations', ['acceptInvite']),
    ...mapMutations('cabinet/invitations', ['removeInviteById']),
    inviteText(username, space) {
      return this.$t('youHaveInviteFrom', {username, space})
    },
    accept(id) {
      this.acceptInvite(id).then(res => {
        if (res.body.success) {
          if (!this.user_info.data.space_id) {
            //setPrimary spaceId if space_id is null
            this.setUserPrimarySpaceId(res.body.data.space_id);
            this.getActiveSpaces();
          }
          this.removeInviteById(id)
        }
      })
    },
    goToCreate() {
      this.$router.push({name: 'create-accounting'})
    }
  },
  i18n: {
    messages: {
      en: {
        welcomeTitle: 'Welcome to Moneykeeper!',
        hasInvitesText: 'You have an invitation to the accounting system. <br> You can accept the invitation, or create your own accounting system.',
        youHaveInviteFrom: '<span class="font-bold">{username}</span> invites you to do joint bookkeeping <span class="font-bold">{space}</span>',
        acceptInvite: 'Accept invite',
        or: 'or',
        createSpaceText: 'Create accounting system'
      },
      ru: {
        welcomeTitle: 'Добро пожаловать в Moneykeeper!',
        hasInvitesText: 'У вас есть приглашение к ведению учета. <br> Вы можете принять приглашение, либо завести собственную систему учета.',
        youHaveInviteFrom: '<span class="font-bold">{username}</span> приглашает вас вести совместную бухгалтерию <span class="font-bold">{space}</span>',
        acceptInvite: 'Принять приглашение',
        or: 'или',
        createSpaceText: 'Создать свою бухгалтерию'
      }
    }
  }
}
</script>
